<div class="cb-avatar" [ngClass]="['cb-size-' + size()]">
  @if(type() !== 'textOnly'){
  <div class="cb-avatar-image" [style.backgroundColor]="randomColor() ? generatedRandomBackground() : null"
    [style.backgroundImage]="(type() === 'image' && url() && url()!.length>0) ? 'url('+url()+')' : null">
    <!-- placeholder -->
    @if (type() === 'placeholder') {
    <cb-icon [style.color]="randomColor() ? generatedRandomIconColor() : null" name="cb-base-outline-user"></cb-icon>
    }
    <!-- icon -->
    @if (type() === 'icon' && profileIcon()){
    <cb-icon [style.color]="randomColor() ? generatedRandomIconColor() : null" class="cb-custom-icon"
      [name]="profileIcon()!"></cb-icon>
    }
    <!-- text -->
    @if (type() === 'initials') {
    <p [style.color]="randomColor() ? generatedRandomTextColor() : null">{{initials()}}</p>
    }

    <!-- icontype -->
    @if (iconType() != 'none') {

    <div class="cb-avatar-icon" [ngClass]="['cb-icontype-' + iconType]">
      <!-- switch -->

      @switch (iconType()) {
      <!-- dot -->
      @case ('dot') { }
      <!-- verified -->
      @case ('verified') {
      <cb-icon name="cb-base-bold-verified-tick"></cb-icon>

      }
      <!-- custom -->
      @case ('custom') {
      <cb-icon [name]="icon() ?? ''"></cb-icon>

      } }
    </div>

    }
  </div>
  }
  @if ((label() || subtitle()) && !onlyAvatar()) {
  <div class="cb-avatar-text">
    <p>
      {{ label() }}
    </p>
    <span>
      {{ subtitle() }}
    </span>
  </div>
  }
</div>